export default __webpack_public_path__ + "static/media/CS-Z35VKR.01872bf2.jpg";